import { PersonMeta } from "./PersonMeta";
import {
  AppShow,
  AppShowActions,
  AppShowCard,
  AppShowContent,
  AppShowSection,
  AppShowSectionHeader,
  AppShowTextField,
  AppShowFunctionField,
} from "@/adapters/inbound/layout";

export const PersonShow = () => (
  <AppShow actions={<AppShowActions />} aside={<PersonMeta />}>
    <AppShowCard>
      <AppShowContent>
        <AppShowSection>
          <AppShowSectionHeader
            title="Person"
            subtitle="Grunddaten und Anzeigename."
          />
          <AppShowTextField source="displayName" label="Name" emptyText="—" />
          <AppShowTextField
            source="preferredName"
            label="Rufname"
            emptyText="—"
          />
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Kontakt"
            subtitle="Erreichbarkeit der Person."
          />
          <AppShowTextField
            source="mobilePhoneE164"
            label="Mobil"
            emptyText="—"
          />
          <AppShowTextField source="email" label="E-Mail" emptyText="—" />
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Status"
            subtitle="Relevante Freigaben und Zugang."
          />
          <AppShowFunctionField
            label="App-Zugang"
            render={(record: any) => (record?.userId ? "Aktiv" : "Kein Zugang")}
          />
        </AppShowSection>
      </AppShowContent>
    </AppShowCard>
  </AppShow>
);
